module.exports = __webpack_public_path__ + "img/H3.4063de22.png";